export default "__VITE_ASSET__qTzneEkw__"